<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col lg="10" md="12" class="d-flex align-items-center mb-4">
                <h2 slot="header" class="mb-0">จัดการลูกค้า</h2>
              </b-col>
              <b-col lg="2" md="12" class="text-right">
                <base-button
                  type="primary"
                  class="d-flex align-items-center"
                  block
                  @click="
                    $router.push({
                      name: 'registerCustomer',
                    })
                  "
                >
                  <b-icon icon="plus-circle" class="mr-2"></b-icon> สร้างลูกค้า
                </base-button>
              </b-col>
            </b-row>
            <b-row class="justify-content-end">
              <b-col lg="4" md="12" class="mb-2">
                <b-form-input
                  v-model="searchTerm"
                  @input="onSearchInput"
                  placeholder="ค้นหา"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-4">
              <b-col>
                <b-table
                  responsive
                  :fields="fields"
                  :items="customers"
                  :busy="isLoading"
                >
                  <template #cell(index)="data">
                    {{
                      calculateIndex(
                        data,
                        pagination.currentPage,
                        pagination.perPage
                      )
                    }}
                  </template>
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>
                  <template #cell(manage)="data">
                    <b-button
                      variant="outline-border"
                      size="sm"
                      @click="
                        $router.push({
                          name: 'manageCustomerId',
                          params: { id: data.item.id },
                        })
                      "
                    >
                      <b-icon icon="eye-fill"></b-icon>
                    </b-button>
                    <b-button variant="outline-danger" size="sm">
                      <b-icon
                        icon="trash-fill"
                        @click="openModalConfirm(data.item.id)"
                      ></b-icon>
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex justify-content-end">
                <b-pagination
                  v-model="pagination.currentPage"
                  :disabled="isLoading"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.perPage"
                  aria-controls="my-table"
                  class="mt-3"
                  @change="(page) => getCustomer(page)"
                ></b-pagination>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
      <ModalConfirm
        ref="confirmDelete"
        :confirm="confirm"
        @confirmModal="removeCustomer"
      /> 
    </b-container>
  </div>
</template>
<script>
import { modalSuccess, modalError } from '@/util/alert.js'
import calculateIndex from "@/util/calculateIndex.js";
import customerServices from "@/api/customer.service.js";
import createDebouncedFunction from "@/util/debounce.js";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import { getCancelToken } from "@/util/axiosCancel";

export default {
  props: {},
  components: { ModalConfirm },
  data() {
    return {
      calculateIndex,
      isLoadPage: false,
      isLoading: false,
      searchTerm: "",
      pagination: {
        currentPage: 1,
        perPage: 10,
        rows: 0, // จำนวนข้อมูลทั้งหมด
      },
      customers: [],
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "shop_name",
          label: "ชื่อร้าน",
        },
        {
          key: "name",
          label: "ชื่อ-นามสกุล",
          formatter: (value, key, item) => {
            return `${item.firstname} ${item.lastname}`;
          },
        },
        {
          key: "phonenumber",
          label: "เบอร์โทรศัพท์",
        },
        {
          key: "email",
          label: "email",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
      confirm: {
        show: false,
        icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
        emphasize: "ต้องการลบรายการ",
        text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
        isLoad: false,
        id: null
      },
    };
  },
  created() {
    this.getCustomer();
  },
  methods: {
    onSearchInput: createDebouncedFunction(function() {
      this.getCustomer();
    }, 500),
    async getCustomer(page = 1) {
      this.isLoading = true;
      this.isLoadPage = true;
      try {
        const cancelToken = getCancelToken();
        const response = await customerServices.getCustomer(
          {
            page,
            search: this.searchTerm,
          },
          cancelToken
        );

        const data = response.data.data
        this.customers = data.items;
        this.pagination.totalRows = data.meta.totalItems;
        this.pagination.perPage = data.meta.itemsPerPage;
        this.pagination.currentPage = data.meta.currentPage;
        
      } catch (error) { 

      } finally { 
        this.isLoading = false;
        this.isLoadPage = false;
      }
    },
    async removeCustomer() {
      try {
        this.isLoadPage = true; 
        await customerServices.removeCustomer(this.confirm.id);

        modalSuccess(this.$bvModal, 'ลบลูกค้าสำเร็จ')
        this.getCustomer();
        this.$refs.confirmDelete.closeModalConfirm();
      } catch (error) {
        modalError(this.$bvModal, 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        console.error("Error removing customer", error);
      }finally { this.isLoadPage = false }
    },
    openModalConfirm(customerId){
      this.confirm.show = true
      this.confirm.id = customerId
      this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
      this.confirm.emphasize = "ต้องการลบลูกค้า ?";
      this.confirm.text = "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
    },
  },
  mounted() {},
};
</script>
